export default "__VITE_ASSET__kjpb$jEp__"